<template>
    <div class="data-ingredient" style="text-align:left">
      <div class="page-header" style="margin-bottom:15px">字段类别</div>
      <el-row  style="padding:0 15px 0 15px">
      <el-col :span="20">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="4"  :style="{'textAlign':'right'}">
        <div style="cursor:pointer" @click="handleAdd()">
          <svg-icon :style="{'color':'#27B1A2'}" icon-class="add"></svg-icon>
        </div>
      </el-col>
    </el-row>
        <div class="table-container" style="padding:0 15px 0 15px">
        <el-table ref="dictTable"
                  :data="list"
                  style="width: 100%;"
                  v-loading="listLoading" border>
          <el-table-column
            width="50"
            label="序号">
            <template slot-scope="scope"><span>{{scope.$index+(listQuery.pageNum - 1) * listQuery.pageSize + 1}} </span></template>
          </el-table-column>								
          <el-table-column label="类别名称" align="center" prop="name">
          </el-table-column>
          <el-table-column label="类别编码" align="center" prop="code">
          </el-table-column>
          <el-table-column label="创建时间" align="center">
            <template slot-scope="scope">{{scope.row.createDate | formatDateTime}}</template>
          </el-table-column>
          <el-table-column label="是否启用" width="140" align="center">
            <template slot-scope="scope">
              <el-switch
                @change="handleStatusChange(scope.$index, scope.row)"
                :active-value="0"
                :inactive-value="1"
                v-model="scope.row.delFlag">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button size="mini"
                        type="text"
                        @click="handleUpdate(scope.$index, scope.row)">
                编辑
              </el-button>
              <!-- <el-button size="mini"
                        type="text"
                        @click="handleDelete(scope.$index, scope.row)">删除
              </el-button> -->
            </template>
          </el-table-column>
        </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="listQuery.pageNum"
        :page-size="listQuery.pageSize"
        :page-sizes="[10,15,20]"
        :total="total">
      </el-pagination>
    </div>
		<el-dialog
      :title="isEdit?'编辑类别':'添加类别'"
      :visible.sync="dialogVisible"
      width="40%">
      <el-form :model="dict"
               ref="dictForm"
               :rules="dictFormRules"
               label-width="75px" size="mini">
        <el-form-item prop="name" label="类别名称：">
          <el-input v-model="dict.name"></el-input>
        </el-form-item>       
        <el-form-item prop="code" label="类别编码：">
          <el-input v-model="dict.code"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleDialogConfirm()" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {fetchList,createDict,updateDict,updateStatus,deleteDict } from '@/api/dict';
  import {formatDate} from '@/utils/date';

  const defaultListQuery = {
    flag: 0,
    pageNum: 1,
    pageSize: 10
  };
  const defaultDict = {
    id: null,
    name: null,
    code: null
  };
  export default {
    name: 'dictTypeList',
    data() {
      return {
        listQuery: Object.assign({}, defaultListQuery),
        list: null,
        total: null,
        listLoading: false,
        dialogVisible: false,
        dict: Object.assign({}, defaultDict),
        isEdit: false,
        dictFormRules:{}
      }
    },
    created() {
      this.getList();
    },
    filters: {
      formatDateTime(time) {
        if (time == null || time === '') {
          return 'N/A';
        }
        let date = new Date(time);
        return formatDate(date, 'yyyy年MM月dd日 hh:mm')
      }
    },
    methods: {
      handleSearchList() {
        this.listQuery.pageNum = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.pageNum = val;
        this.getList();
      },
      handleAdd() {
        this.dialogVisible = true;
        this.isEdit = false;
        this.dict = Object.assign({},defaultDict);
      },
      handleStatusChange(index, row) {
        this.$confirm('是否要修改该状态?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          updateStatus(row.id, {status: row.delFlag}).then(response => {
            this.$message({
              type: 'success',
              message: '修改成功!'
            }); 
          });
        }).catch(() => {
        });
      },
      handleDelete(index, row) {
        this.$confirm('是否要删除该类别? 删除后某些功能将不可用', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteDict(row.id).then(response => {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.getList();
          });
        });
      },
      handleUpdate(index, row) {
        this.dialogVisible = true;
        this.isEdit = true;
        this.dict = Object.assign({},row);
      },
      handleDialogConfirm() {
        this.$refs['dictForm'].validate(valid => {
          if (valid) {  
            if (this.isEdit) {
              updateDict(this.dict).then(response => {
                this.$message({
                  message: '修改成功！',
                  type: 'success'
                });
                this.dialogVisible =false;
                this.getList();
              })
            } else {
              createDict(0,this.dict).then(response => {
                this.$message({
                  message: '添加成功！',
                  type: 'success'
                });
                this.dialogVisible =false;
                this.getList();
              })
            }
          }
        })
      },
      getList() {
        this.listLoading = true;
        fetchList(this.listQuery).then(response => {
          this.listLoading = false;
          this.list = response.data.list;
          this.total = response.data.total;
        });
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/aicenter/components/dict/dict-type-list.vue